import {
  deliveryForecastDisplayValue,
  statusRequiresDeliveryForecast,
} from './postSaleStatusDeadline';

const enabled = value => [true, 1, '1'].includes(value);

export { statusRequiresDeliveryForecast };

const snapshotOf = (payload, key) => payload[key] || {};

const annotationTypeIds = value =>
  (Array.isArray(value) ? value : [value])
    .map(item => (typeof item === 'object' ? item.id : item))
    .filter(Boolean)
    .map(item => String(item));

const annotationSellers = payload => {
  const sellers = payload.vendedores_averb || payload.averbacao || [];

  return (Array.isArray(sellers) ? sellers : []).map(seller => ({
    id: String(seller.id || seller.seller_id || ''),
    tipo: annotationTypeIds(
      seller.tipo || seller.annotation_type_ids || seller.tipo_averbacao
    ),
  }));
};

export const initialStatus = ({ agendaAction, status } = {}) =>
  agendaAction === 'schedule_deed' ? 'escritura' : status || '';

export function defaultTransitionForm(caseData = {}) {
  const payload = caseData.status_payload || {};
  const engineering = snapshotOf(payload, 'engenharia')[0] || {};
  const bankDocumentation = snapshotOf(payload, 'banco_documentos')[0] || {};
  const deed = snapshotOf(payload, 'escritura');
  const registry = snapshotOf(payload, 'registro');

  return {
    status_due_at: deliveryForecastDisplayValue(caseData.status_due_at),
    reason: '',
    responsavel_vendedor: payload.responsavel_vendedor || '',
    responsavel_comprador: payload.responsavel_comprador || '',
    banco: payload.banco || engineering.banco_id || '',
    data_engenharia:
      payload.data_engenharia || engineering.data_engenharia || '',
    hora_engenharia:
      payload.hora_engenharia || engineering.hora_engenharia || '',
    check_engenharia: enabled(
      payload.check_engenharia ?? engineering.check_engenharia
    ),
    check_banco: {
      doc_vendedor: enabled(
        payload.check_banco?.doc_vendedor ?? bankDocumentation.doc_vendedor
      ),
      doc_comprador: enabled(
        payload.check_banco?.doc_comprador ?? bankDocumentation.doc_comprador
      ),
      doc_imovel: enabled(
        payload.check_banco?.doc_imovel ?? bankDocumentation.doc_imovel
      ),
    },
    local_escritura: payload.local_escritura || deed.cartorio_id || '',
    nome_cartorio: payload.nome_cartorio || deed.local_escritura || '',
    data_escritura: payload.data_escritura || deed.data_escritura || '',
    hora_escritura: payload.hora_escritura || deed.hora_escritura || '',
    cep_escritura: payload.cep_escritura || deed.cep || '',
    endereco_escritura: payload.endereco_escritura || deed.logradouro || '',
    numero_escritura: payload.numero_escritura || deed.numero || '',
    unidade_escritura: payload.unidade_escritura || deed.unidade || '',
    complemento_escritura:
      payload.complemento_escritura || deed.complemento || '',
    cidade_escritura: payload.cidade_escritura || deed.cidade || '',
    estado_escritura: payload.estado_escritura || deed.uf || '',
    bairro_escritura: payload.bairro_escritura || deed.bairro || '',
    tipo_rgi: payload.tipo_rgi || registry.tipo_rgi_id || '',
    protocolo_rgi: payload.protocolo_rgi || registry.protocolo_rgi || '',
    check_registro: enabled(payload.check_registro ?? registry.check_registro),
    pendencia_taxa: Array.isArray(payload.pendencia_taxa)
      ? payload.pendencia_taxa
      : [],
    quant_vendedores_averb:
      payload.quant_vendedores_averb || annotationSellers(payload).length || '',
    vendedores_averb: annotationSellers(payload),
  };
}

const deedPayload = form => ({
  local_escritura: form.local_escritura,
  nome_cartorio: form.nome_cartorio,
  data_escritura: form.data_escritura,
  hora_escritura: form.hora_escritura,
  cep_escritura: form.cep_escritura,
  endereco_escritura: form.endereco_escritura,
  numero_escritura: form.numero_escritura,
  unidade_escritura: form.unidade_escritura,
  complemento_escritura: form.complemento_escritura,
  cidade_escritura: form.cidade_escritura,
  estado_escritura: form.estado_escritura,
  bairro_escritura: form.bairro_escritura,
});

export function transitionFormPayload(status, form) {
  switch (status) {
    case 'taxas':
      return {
        responsavel_vendedor: form.responsavel_vendedor,
        responsavel_comprador: form.responsavel_comprador,
        pendencia_taxa: form.pendencia_taxa,
      };
    case 'itbi':
      return { responsavel_comprador: form.responsavel_comprador };
    case 'engenharia':
      return {
        banco: form.banco,
        data_engenharia: form.data_engenharia,
        hora_engenharia: form.hora_engenharia,
        check_engenharia: Boolean(form.check_engenharia),
      };
    case 'banco_documentacao':
      return { check_banco: { ...form.check_banco } };
    case 'escritura':
      return deedPayload(form);
    case 'registro':
      return {
        tipo_rgi: form.tipo_rgi,
        protocolo_rgi: form.protocolo_rgi,
        check_registro: Boolean(form.check_registro),
      };
    case 'averbacao':
      return {
        quant_vendedores_averb: form.quant_vendedores_averb,
        vendedores_averb: form.vendedores_averb,
      };
    default:
      return {};
  }
}
